// extracted by mini-css-extract-plugin
module.exports =  {"popupFieldComponent":"Claims_popupFieldComponent__CNv-U","contactDetailsLink":"Claims_contactDetailsLink__JfLAh"};